import type { ReactNode } from 'react'
import PreviewImage from './PreviewImage'

export type DocumentPreviewPage = {
  page_ref: string
  ordinal: number
  preview_url?: string | null
  title?: string
  source_file_name?: string | null
}

/** Shared continuous page preview used by the library, projects and citation dialogs. */
export default function DocumentPreviewPages({ pages, label = '文档页面预览', renderActions, renderBody }: {
  pages: readonly DocumentPreviewPage[]
  label?: string
  renderActions?: (page: DocumentPreviewPage) => ReactNode
  renderBody?: (page: DocumentPreviewPage) => ReactNode
}) {
  return <div className="preview-modal-pages" aria-label={label}>
    {pages.map(page => {
      const key = page.page_ref ?? String(page.ordinal)
      return <figure key={key} className="preview-modal-page" data-page-ref={page.page_ref}>
        <figcaption><span>第 {page.ordinal} 页{page.title ? ` · ${page.title}` : ''}</span>{renderActions?.(page)}</figcaption>
        {renderBody?.(page) ?? (page.preview_url ? <PreviewImage src={page.preview_url} alt={`${page.title ?? '文档'}第 ${page.ordinal} 页预览`} loading="lazy" /> : <div className="preview-page-missing" role="status">该页暂未生成预览图。</div>)}
      </figure>
    })}
  </div>
}
